// deps
import React, { memo } from "react";

// Styles
import {
    ShimmerContainer,
    ShimmerRow,
    TextPlaceholder,
    ShimmerWrapper,
    ShimmerColumn,
    ShimmerTextWrapper,
} from "./styles";

// constants
import { PLACEHOLDER_DIMENSIONS } from "./constants";

const PlaceholderTextGroup = () => (
    <>
        <ShimmerTextWrapper>
            <TextPlaceholder width={PLACEHOLDER_DIMENSIONS.iconWidth} height={PLACEHOLDER_DIMENSIONS.iconHeight} />
            <TextPlaceholder
                width={PLACEHOLDER_DIMENSIONS.textWidth}
                height={PLACEHOLDER_DIMENSIONS.textHeight}
                cornerRadius={PLACEHOLDER_DIMENSIONS.textCornerRadius}
            />
        </ShimmerTextWrapper>
        <TextPlaceholder
            width={PLACEHOLDER_DIMENSIONS.smallTextWidth}
            height={PLACEHOLDER_DIMENSIONS.smallTextHeight}
            cornerRadius={PLACEHOLDER_DIMENSIONS.smallTextCornerRadius}
        />
    </>
);

const DeliverySectionShimmer = () => (
    <ShimmerWrapper>
        <ShimmerContainer>
            <ShimmerRow>
                <TextPlaceholder
                    height={PLACEHOLDER_DIMENSIONS.mainTextHeight}
                    cornerRadius={PLACEHOLDER_DIMENSIONS.mainTextCornerRadius}
                />
            </ShimmerRow>
            <ShimmerColumn>
                <PlaceholderTextGroup />
            </ShimmerColumn>
            <ShimmerColumn>
                <PlaceholderTextGroup />
            </ShimmerColumn>
        </ShimmerContainer>
    </ShimmerWrapper>
);

export default memo(DeliverySectionShimmer);
